import styled from 'styled-components';
import {useLoggedIn, useStorePost} from '../store';
import useModal from "../modals";
import {themecolors} from "../utils/themecolors";
import Sheet from "./bottom-sheet/sheet";
import SignupPromptSheet from "./bottom-sheet/signup_prompt";
import React from "react";
import {useSheetModal} from "./test/ModalContext";

const CommentProp = styled.div``;

const CreatePrompt = styled(({className, message, postId}) => {
    const modal = useModal();
    const loggedIn = useLoggedIn();
    const {post} = useStorePost(postId);
    const { openModal } = useSheetModal();
    const handleComment = () => {
        if (!loggedIn) {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else if (postId) {
            if (post.is_locked) return;
            modal.open('CreateComment', {postId});
        } else {
            modal.open('CreateMessage',  {message});
        }
    }
    return (
        <footer className={className} onClick={handleComment}>
            <CommentProp>{(postId && post.is_locked) ? 'Post is locked by moderators.' : `Add ${postId ? 'comment' : 'message'}`}</CommentProp>
        </footer>
    )
})`
  position: fixed;
  bottom: 0;
  width: 100%;

  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : themecolors.lighter_border};
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_1 : theme.footer.backgroundColor};
  
  svg {
    margin: 0 6px;
  }
  
  ${CommentProp} {
    width: calc(100% - 24px);
    height: 38px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.light_input};
    border-radius: 4px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    line-height: 38px;
    padding: 0 16px;
    font-size: 14px;
  }  
`;

export default CreatePrompt;
